import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://kokanhomestays.in";

/**
 * Reusable SEO component — adds canonical, robots, OG tags, and title to every page.
 * Usage: <PageSEO title="Page Title" description="..." path="/current-path" image="..." noindex={false} />
 */
const PageSEO = ({ title, description, path, image, noindex = false, type = "website", canonicalUrl: customCanonical }) => {
  const location = useLocation();
  const currentPath = path || location.pathname;
  const canonicalUrl = customCanonical || `${SITE_URL}${currentPath}`;
  const fullTitle = title || "Kokan Homestays";

  useEffect(() => {
    // Title
    document.title = fullTitle;

    const setMeta = (attr, attrVal, content) => {
      let el = document.querySelector(`meta[${attr}="${attrVal}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, attrVal);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    // Canonical
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", canonicalUrl);

    // Robots
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");

    // Description
    if (description) setMeta("name", "description", description);

    // Open Graph
    setMeta("property", "og:type", type);
    setMeta("property", "og:url", canonicalUrl);
    setMeta("property", "og:title", fullTitle);
    if (description) setMeta("property", "og:description", description);
    if (image) setMeta("property", "og:image", image);
    setMeta("property", "og:site_name", "Kokan Homestays");

    // Twitter Card
    setMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
    setMeta("name", "twitter:title", fullTitle);
    if (description) setMeta("name", "twitter:description", description);
    if (image) setMeta("name", "twitter:image", image);

    // Cleanup on unmount
    return () => {};
  }, [fullTitle, description, canonicalUrl, image, noindex, type]);

  return null;
};

export default PageSEO;
